import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { EventEmitter } from '../../../../common';
export var UIEventEmitter = function (_EventEmitter) {
  _inherits(UIEventEmitter, _EventEmitter);

  var _super = _createSuper(UIEventEmitter);

  function UIEventEmitter() {
    _classCallCheck(this, UIEventEmitter);

    return _super.apply(this, arguments);
  }

  _createClass(UIEventEmitter, null, [{
    key: "getInstance",
    value: function getInstance() {
      if (!this._uiEventEmitter) {
        this._uiEventEmitter = new UIEventEmitter();
      }

      return this._uiEventEmitter;
    }
  }]);

  return UIEventEmitter;
}(EventEmitter);

_defineProperty(UIEventEmitter, "_uiEventEmitter", void 0);